import { FC, HTMLProps } from 'react'

import { cn } from 'src/lib/cn'

interface SeparatorVerticalProps extends HTMLProps<HTMLDivElement> {
  withoutMargin?: boolean
  lineClassName?: string
}

const SeparatorVertical: FC<SeparatorVerticalProps> = ({
  withoutMargin,
  lineClassName,
  className,
  ...divProps
}) => {
  const classes = cn('flex relative mx-[17px] h-[13.9px]', withoutMargin && 'mx-0', className)

  return (
    <div className={classes} data-testid="separator-vertical" {...divProps}>
      <div
        className={cn(
          'bg-bombay absolute top-1/2 h-full w-px -translate-y-1/2 rounded-[0.5px]',
          lineClassName,
        )}
      />
    </div>
  )
}

export default SeparatorVertical
